import { cn } from '@/lib/utils';
import BookingStateSection from './BookingStateSection';
import DraftSection from './DraftSection';
import RecentChangesSection from './RecentChangesSection';
import RelatedPeopleSection from './RelatedPeopleSection';

interface DetailsSidebarProps extends React.HTMLAttributes<HTMLDivElement> {
  bookingId: string;
  isEditing: boolean;
  /** Osoba, na której ekranie stoimy — jej wiersz nie jest odnośnikiem. */
  currentPersonId?: string;
  /**
   * Ile pozycji szkicu dotyczy tego ekranu. Podane — karta szkicu mówi
   * „5 · w tym 3 tutaj”; pominięte (ekran rezerwacji) — samo „5 pozycji”.
   */
  localDraftItemCount?: number;
  /** Wyjście z trybu edycji — „Zapisz i wyjdź” oraz odrzucenie szkicu. */
  onExitEditing: () => void;
}

/**
 * Panel boczny ekranów operatora. Tryb podglądu pokazuje stan rezerwacji,
 * obsadę i ostatnie zmiany; tryb edycji zamienia stan rezerwacji na karty
 * szkicu, bo w edycji liczy się to, co paczka dopiero zrobi.
 *
 * Każda sekcja sama pobiera swoje dane i sama decyduje, czy w ogóle się
 * pokazać — panel odpowiada wyłącznie za dobór sekcji do trybu.
 */
const DetailsSidebar = ({
  bookingId,
  isEditing,
  currentPersonId,
  localDraftItemCount,
  onExitEditing,
  className,
  ...props
}: DetailsSidebarProps) => (
  <div className={cn('flex flex-col gap-3.5', className)} {...props}>
    {isEditing ? (
      <DraftSection
        bookingId={bookingId}
        localDraftItemCount={localDraftItemCount}
        onExitEditing={onExitEditing}
      />
    ) : (
      <BookingStateSection bookingId={bookingId} />
    )}

    <RelatedPeopleSection
      bookingId={bookingId}
      currentPersonId={currentPersonId}
    />

    {!isEditing && <RecentChangesSection bookingId={bookingId} />}
  </div>
);

export default DetailsSidebar;
